import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "documents", spoke: "documents", title: "Documents", icon: FolderOutlinedIcon, order: 60, entries: [
  { label: "Library", to: "/app/documents", permission: "documents.library.view" },
  { label: "Document templates", to: "/app/documents/templates", permission: "documents.template.view" },
  { label: "Label designer", to: "/app/documents/labels", permission: "documents.template.view" },
  { label: "Print queue", to: "/app/documents/print-queue", permission: "documents.print.view" },
  { label: "Categories", to: "/app/masterdata/document-categories", permission: "documents.library.manage" },
] });
